import React from 'react'
import Home from "../components/UI/Home"
import LoadScreen from "../components/UI/LoadScreen/LoadScreen"

export default function HomePage() {
    return <LoadScreen component={<Home />} />
}
